export default "__VITE_ASSET__aWSCAGOP__"